import React from 'react';
import {
  FieldInputProps,
  FieldMetaProps,
} from '../../Constants/ReduxFormPropTypes';

const CancelAcceptField = ({ input, meta }) => (
  <div className="col-sm form-group">
    <div className="custom-control custom-checkbox">
      <input
        {...input}
        id={input.name}
        type="checkbox"
        className="custom-control-input"
        aria-label="Cancel accept checkbox"
      />

      <label
        htmlFor={input.name}
        className={
          meta.touched && meta.error
            ? 'label form-error__label custom-control-label'
            : 'label custom-control-label'
        }
      >
        &nbsp;&nbsp;Yes, I wish to cancel my policy in full.
      </label>
      {meta.touched && meta.error && (
        <div className="form-error ml-2">{meta.error}</div>
      )}
    </div>
  </div>
);
CancelAcceptField.propTypes = {
  input: FieldInputProps.isRequired,
  meta: FieldMetaProps.isRequired,
};

export default CancelAcceptField;
